import Vue from 'vue'
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex)
const vuexLoval = new VuexPersistence({
	storage: window.localStorage,
});

export default new Vuex.Store({
	state: {
		userInfo:{
			nickName: '', // 用户名称
			actNo: '', // 用户编号
			avatarUrl: '', // 用户头像
			signature: '', // 用户签名
		},
		token:{
			uuid: '', // 令牌ID
			tokenValue: '', // 令牌值
			tokenExpiry: '', // 令牌过期时间
		},
	},
	mutations: {
		set_userInfo: (state,userInfo)=>{
			state.userInfo = userInfo;
		},
		set_token: (state,token)=>{
			state.token = token;
		},
	},
	getters: {
		userInfo: state=>state.userInfo,
		token: state=>state.token,
	},
	actions: {

	},
	plugins: [vuexLoval.plugin],
})
